import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { waUrl } from "../lib/site";

export default function CTABand({
  title = "Pronto para gerar mais clientes?",
  subtitle = "Solicite uma análise gratuita e descubra como podemos acelerar o crescimento do seu negócio.",
  primaryLabel = "Solicitar Orçamento",
  primaryTo = "/contato",
  whatsappMsg = "Olá! Quero solicitar uma análise gratuita.",
  testId = "cta-band",
}) {
  return (
    <section data-testid={testId} className="bg-[#000000] text-white relative">
      <div className="g-stripe" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 sm:py-28">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <p className="eyebrow text-white/50 mb-5">Vamos conversar</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter leading-[1.05]">
              {title}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-white/70 leading-relaxed mb-8">{subtitle}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to={primaryTo}
                data-testid={`${testId}-primary`}
                className="inline-flex items-center justify-center gap-2 bg-white text-[#000000] px-6 py-4 font-medium hover:bg-gray-100 transition"
              >
                {primaryLabel}
                <ArrowUpRight size={18} />
              </Link>
              <a
                href={waUrl(whatsappMsg)}
                target="_blank"
                rel="noreferrer"
                data-testid={`${testId}-whatsapp`}
                className="btn-whatsapp justify-center"
              >
                <MessageCircle size={18} />
                Falar no WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
